import { FC, useCallback, useState } from "react";
import styles from "./Registration.module.css";
import Passport from "./components/Passport";
import { useNavigate } from "react-router-dom";
import Phone from "./components/Phone";
import { useAppDispatch } from "../../store";
import Email from "./components/Email";
import ConfirmCode from "./components/ConfirmCode";
import { InvisibleSmartCaptcha } from "@yandex/smart-captcha";
import { tabsNamesKeys } from "./Registration.models";
import { SetVerifyToken } from "../../store/slices/registrationSlice";
import { Password } from "./components/Password";

const Registration: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [visible, setVisible] = useState(true);
  const [step, setStep] = useState(tabsNamesKeys.passport);

  const handleButtonClick = () => setVisible(true);
  const handleChallengeHidden = useCallback(() => setVisible(false), []);

  const setStepHandler = (step: tabsNamesKeys) => {
    if (step === tabsNamesKeys.passport) {
      handleButtonClick();
    }
    if (step === tabsNamesKeys.exit) {
      navigate("/login");
      return;
    }

    setStep(step);
  };

  const setVerifyToken = (token: string) => {
    dispatch(SetVerifyToken(token));
  };

  return (
    <div className={styles.registrationContainer}>
      <div className={styles.registration}>
        <h2 className={styles.title}>Регистрация</h2>
        {step === tabsNamesKeys.passport && (
          <Passport setStep={setStepHandler} />
        )}
        {step === tabsNamesKeys.phone && (
          <Phone setStep={setStepHandler} />
        )}
        {step === tabsNamesKeys.email && (
          <Email setStep={setStepHandler} />
        )}
        {step === tabsNamesKeys.confirmCode && <ConfirmCode setStep={setStepHandler} />}

        {step === tabsNamesKeys.password && <Password setStep={setStepHandler} />}

        <InvisibleSmartCaptcha
          key={visible ? "captchaVisible" : "captchaHidden"}
          sitekey={`${process.env.REACT_APP_CLIENT_KEY}`}
          onChallengeHidden={handleChallengeHidden}
          onSuccess={setVerifyToken}
          visible={visible}
        />
      </div>
    </div>
  );
};

export default Registration;
